<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Sổ sách Giáo viên"
          :link="[
            {
              text: 'Cấp học',
              href: '/teachingDoc'
            },
            {
              text: 'Sổ sách giảng dạy'
            }
          ]"
        />
      </div>
    </div>
    <div id="app">
      <div v-if="isLoading" class="center-screen">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div v-else>
        <div v-for="(node, index) in organizedData" :key="index">
          <TreeNode :node="node" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeNode from '@/components/basic/tree/TreeNode.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapGetters } from 'vuex'
import { TeacherCat } from '../../plugins/api'
export default {
  components: {
    TreeNode,
    Breadcrumbs
  },
  data() {
    return {
      organizedData: [],
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('auth', ['profile'])
  },
  mounted() {
    this.initializeTeachingsTree()
  },
  methods: {
    ...mapActions('teacherDoc', ['fetchTeachings']),

    async initializeTeachingsTree() {
      this.isLoading = true
      const type = this.$route.params.level
      try {
        this.organizedData = await TeacherCat.fetchTree(type, 'admin')
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
